
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';
import RoleSelector from '@/components/auth/RoleSelector';
import EnhancedSignUpForm from '@/components/auth/EnhancedSignUpForm';
import { ArrowLeft } from 'lucide-react';
import Header from '@/components/Header';

const SignUp = () => {
  const [step, setStep] = useState<'role' | 'form'>('role');
  const [selectedRole, setSelectedRole] = useState<'student' | 'landlord' | null>(null);
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleRoleSelect = (role: 'student' | 'landlord') => {
    setSelectedRole(role);
    setStep('form');
  };

  const handleBack = () => {
    if (step === 'form') {
      setStep('role');
      setSelectedRole(null);
    } else {
      navigate('/signin');
    }
  };

  const handleSignUpComplete = () => {
    // Navigate to account page to complete profile
    navigate('/account');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 to-accent/5">
      <Header />
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                {t('create_account', 'إنشاء حساب', 'Create Account')}
              </CardTitle>
              <CardDescription>
                {step === 'role' 
                  ? t('choose_account_type', 'اختر نوع الحساب', 'Choose your account type')
                  : t('complete_registration', 'أكمل التسجيل', 'Complete your registration')
                }
              </CardDescription>
            </CardHeader>
            <CardContent>
              {step === 'role' ? (
                <RoleSelector onRoleSelect={handleRoleSelect} />
              ) : (
                <EnhancedSignUpForm 
                  role={selectedRole!} 
                  onBack={handleBack}
                  onComplete={handleSignUpComplete}
                />
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
